// FT-195: секреты интеграций компании «только на запись».
//
// Сервер рядом с каждым секретом отдаёт признак `<секрет>_set`, а вместо значения — маску (или ничего). Фронт:
//   - признак «интеграция подключена» берёт из `<секрет>_set`, не из значения;
//   - в поле ввода секрета не показывает сохранённое (поле пустое, подсказка «задан»);
//   - при сохранении шлёт только набранное: пустое и маску сервер считает «не менять»;
//   - стирает секрет явным `clear_secrets: [поле]`.

// Признак «секрет задан». Без `_set` (снимок компании в localStorage старше сервера с признаками) — по значению.
export function secretSet(company, name) {
  if (!company) return false;
  const flag = company[`${name}_set`];
  return flag === undefined ? !!company[name] : !!flag;
}

// Символ маски, которую сервер отдаёт вместо значения секрета. Значение с ним сервер считает «не менять» —
// фронт тоже: такое значение не новый ключ.
const MASK_CHAR = "\u2022";

// Новое значение секрета из поля ввода или null, если набранное значит «не менять» (пусто, пробелы, маска).
// Пробелы по краям ключей и токенов — ошибка вставки, обрезаются; у паролей края — часть значения.
export function typedSecretValue(inputs, name) {
  const value = inputs && inputs[name];
  if (typeof value !== "string" || value.trim() === "" || value.includes(MASK_CHAR)) return null;
  return name.endsWith("password") ? value : value.trim();
}

// Набранные секреты для тела сохранения: только новые значения из перечисленных полей.
export function typedSecrets(inputs, names) {
  const result = {};
  names.forEach((name) => {
    const value = typedSecretValue(inputs, name);
    if (value !== null) result[name] = value;
  });
  return result;
}

// Есть ли в полях ввода хоть один новый секрет — несохранённая правка формы.
export function hasTypedSecrets(inputs, names = Object.keys(inputs || {})) {
  return names.some((name) => typedSecretValue(inputs, name) !== null);
}

// Признаки `<секрет>_set` для коммита в стор, когда ответ сервера компанию не несёт.
export function secretFlags(names, value) {
  return names.reduce((acc, name) => {
    acc[`${name}_set`] = value;
    return acc;
  }, {});
}

// Поле обязательное: заполнено, если набрано новое значение или секрет уже задан.
export function secretProvided(company, inputs, name) {
  return typedSecretValue(inputs, name) !== null || secretSet(company, name);
}

// Секреты, которые сохраняет общая кнопка профиля saveCompany(). У секретов GPS свои кнопки панелей с
// проверками (хост Wialon, пара ключей Autofon) — общее сохранение их не шлёт.
export const SAVE_COMPANY_SECRET_FIELDS = ["teletype_api_key", "yandex_taxi_api_key", "okidoki_api_key", "docuseal_api_key"];

// Секреты панелей GPS (PATCH /api/v1/company кнопками своих панелей).
export const STARLINE_SECRET_FIELDS = ["starline_secret", "starline_password"];
export const WIALON_SECRET_FIELDS = ["wialon_token"];
export const AUTOFON_SECRET_FIELDS = ["autofon_api_key", "autofon_password"];

// Все секреты формы профиля компании (PATCH /api/v1/company): saveCompany() и панели GPS.
export const PROFILE_SECRET_FIELDS = [
  ...SAVE_COMPANY_SECRET_FIELDS,
  ...STARLINE_SECRET_FIELDS,
  ...WIALON_SECRET_FIELDS,
  ...AUTOFON_SECRET_FIELDS,
];
export const STRIPE_SECRET_FIELDS = ["stripe_secret_key", "stripe_webhook_secret"];
export const YANDEX_PAY_SECRET_FIELDS = ["yandex_pay_api_key"];

// Пустой набор полей ввода для data() компонента.
export function blankSecretInputs() {
  return [...PROFILE_SECRET_FIELDS, ...STRIPE_SECRET_FIELDS, ...YANDEX_PAY_SECRET_FIELDS].reduce((acc, name) => {
    acc[name] = "";
    return acc;
  }, {});
}
